import { Card } from '@skupreme/shared/ui';
import { useOrgTab } from '../../api/orgs';
import type { OrgOverview } from '../../api/types';
import { DataTable, type DataColumn } from '../../components/DataTable';
import { QueryView } from '../../components/QueryView';
import { Section } from '../../components/Section';
import { StatusBadge } from '../../components/StatusBadge';
import { Timestamp } from '../../components/Timestamp';

type Division = OrgOverview['divisions'][number];

const DIVISION_COLUMNS: DataColumn<Division>[] = [
  { id: 'name', header: 'Division', cell: division => division.name },
  { id: 'id', header: 'ID', cell: division => division.id },
  {
    id: 'status',
    header: 'Status',
    cell: division => <StatusBadge status={division.status} />,
  },
];

export function OverviewTab({ orgId }: { orgId: string }) {
  return (
    <QueryView query={useOrgTab(orgId, 'overview')}>
      {({ account, divisions, products }) => (
        <>
          <Card
            title="Account"
            action={<StatusBadge status={account.status} />}
          >
            <dl className="sk:grid sk:grid-cols-[max-content_1fr] sk:gap-x-6 sk:gap-y-1 sk:text-dense">
              <dt>Name</dt>
              <dd>{account.name}</dd>
              <dt>ID</dt>
              <dd>{account.id}</dd>
              <dt>Legacy ID</dt>
              <dd>{account.legacy_id ?? '—'}</dd>
              <dt>Created</dt>
              <dd>
                <Timestamp value={account.created_at} />
              </dd>
              <dt>Products</dt>
              <dd>{products.join(', ') || '—'}</dd>
            </dl>
          </Card>
          <Section title="Divisions">
            <DataTable
              label="Divisions"
              columns={DIVISION_COLUMNS}
              rows={divisions}
              getKey={division => division.id}
              empty="No divisions"
            />
          </Section>
        </>
      )}
    </QueryView>
  );
}
